import { render, staticRenderFns } from "./ManageStatus.vue?vue&type=template&id=623590b4&scoped=true"
import script from "./ManageStatus.vue?vue&type=script&lang=js"
export * from "./ManageStatus.vue?vue&type=script&lang=js"
import style0 from "./ManageStatus.vue?vue&type=style&index=0&id=623590b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623590b4",
  null
  
)

export default component.exports